import React from 'react';
import { Link } from 'react-router-dom';
import ScrambleText from '../Components/ScrambleText';
import './Header.css';

import researchImage from '../assets/images/Symposium speaking.jpeg';
import artImage from '../assets/images/MainCharacter.jpeg';
import ridingImage from '../assets/images/riding.jpeg';
import profileImage from '../assets/images/Profile 1.jpeg';

const selectedWork = [
  {
    number: '01',
    category: 'Research',
    title: 'Cancer Research',
    description: 'MMP-2 and TIMP-2 as prognostic markers in cancer research.',
    to: '/projects',
    openItem: 1,
    image: researchImage,
  },
  {
    number: '02',
    category: 'Activities',
    title: 'Beyond the classroom',
    description: 'Leadership, conferences, clinical experience and extracurricular work.',
    to: '/activity',
    openItem: 7,
    image: ridingImage,
    imagePosition: '48% center',
  },
  {
    number: '03',
    category: 'Art',
    title: 'Visual Art',
    description: 'A collection of paintings and drawings across different mediums.',
    to: '/art',
    openItem: 5,
    image: artImage,
  },
];

const Header = () => (
    <main className="home-page">
    <section className="home-hero" aria-labelledby="home-title">
      <div className="home-hero__content">
        {/* <p className="home-eyebrow">Pharmacology · Research · Art</p> */}
        <h1 id="home-title">
          <ScrambleText text={'Shashank\nBalaji'} />
        </h1>
        <p className="home-hero__lead">
          Pharmacology student, researcher and artist based between Dublin and Bangalore.
        </p>
      </div>
      <div className="home-hero__visual">
        <span className="home-orbit home-orbit--one" />
        <span className="home-orbit home-orbit--two" />
        <div className="home-profile" aria-label="Portrait of Shashank">
          <img
            src={profileImage}
            alt="Shashank with a dog"
            fetchPriority="high"
            decoding="async"
          />
        </div>
      </div>
    </section>

    <section className="home-about" aria-labelledby="about-title">
      <div className="home-about__copy">
        <h2 id="about-title"><ScrambleText text="Curiosity across disciplines." /></h2>
        <p>
          I study pharmacology, conduct research, participate in sports
          and make art. This website documents the interests and experiences that have
          shaped how I think.
        </p>
        <Link to="/activity">More about my activities <span aria-hidden="true">→</span></Link>
      </div>
      <div className="home-timeline">
        <article>
          <span>Currently</span>
          <h3><ScrambleText text="BSc Pharmacology" /></h3>
          <p>University College Dublin<br />Dublin, Ireland</p>
        </article>
        <article>
          <span>Previously</span>
          <h3><ScrambleText text="IGCSE & International Baccalaureate" /></h3>
          <p>Greenwood High International School<br />Bangalore, India</p>
        </article>
      </div>
    </section>

    <section className="home-section" aria-labelledby="selected-work-title">
      <div className="home-section__heading">
        <h2 id="selected-work-title"><ScrambleText text="Selected work" /></h2>
        <p>A few places to start.</p>
      </div>
      <div className="home-work-grid">
        {selectedWork.map((work) => (
          <Link
            className="home-work-card"
            to={work.to}
            state={{ openItem: work.openItem, fromHomeCard: true }}
            key={work.number}
          >
            {work.image && (
              <img
                src={work.image}
                alt=""
                loading="lazy"
                decoding="async"
                style={{ objectPosition: work.imagePosition || 'center' }}
              />
            )}
            <span className="home-work-card__shade" />
            <span className="home-work-card__meta">{work.number} — {work.category}</span>
            <span className="home-work-card__content">
              <strong><ScrambleText text={work.title} /></strong>
              <span>{work.description}</span>
            </span>
            <span className="home-work-card__arrow" aria-hidden="true">↗</span>
          </Link>
        ))}
      </div>
    </section>

    </main>
);

export default Header;
